(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["re-product-page"]) return;
  try {
    
function reBuildChoices(root){
 for(const picker of root.querySelectorAll('[data-re-option-picker]')){
  if(picker.dataset.buttonsReady)return;
  picker.dataset.buttonsReady='true';
  const selects=[...picker.querySelectorAll('select')];
  const groups=[];
  for(const select of selects){
   const group=document.createElement('div');group.className='re-choice-group';group.setAttribute('role','group');
   const label=select.parentElement.querySelector('label');group.setAttribute('aria-label',label?.textContent||'');
   for(const option of select.options){if(!option.value)continue;const button=document.createElement('button');button.type='button';button.className='re-choice';button.textContent=option.textContent;button.dataset.value=option.value;button.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));sync();});group.append(button);}
   select.after(group);select.classList.add('re-button-select');select.tabIndex=-1;groups.push({select,group});
  }
  function sync(){for(const {select,group} of groups){for(const button of group.children){const option=[...select.options].find(o=>o.value===button.dataset.value);const disabled=select.disabled||!option||option.disabled;if(button.disabled!==disabled)button.disabled=disabled;button.setAttribute('aria-pressed',String(select.value===button.dataset.value));}}}
  picker.addEventListener('change',sync);sync();
  new MutationObserver(sync).observe(picker,{subtree:true,attributes:true,attributeFilter:['disabled'],childList:true});
 }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>reBuildChoices(document),{once:true});}else{reBuildChoices(document);}
document.addEventListener('shopify:section:load',e=>reBuildChoices(e.target));

  } catch(e) { console.error(e); }
})();
})();
